// extracted by mini-css-extract-plugin
export default {"description":"ProjectInfo_description__pvXvq","mobile":"ProjectInfo_mobile__zqGBz","info":"ProjectInfo_info__zrtBk"};